'use strict';

var GridRemoveSortButtonController = function GridRemoveSortButtonController($scope) {
  var gridPanel = $scope.gridPanelScope;
  $scope.removeFiltering = function () {
    gridPanel.asyncGridApply('clearfilters');
  };
};
GridRemoveSortButtonController.$inject = ['$scope'];
module.exports = GridRemoveSortButtonController;